import { useState } from 'react';
export default function useRowSelection(config) {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const handleSelectRowsChange = (keys, rows) => {
        setSelectedRowKeys(keys);
        setSelectedRows(rows);
    };
    const getSelectedRows = () => {
        return selectedRows;
    };
    return {
        config: (config ? {
            ...config,
            defaultSelectedRowKeys: selectedRowKeys,
            selectedRowKeys,
            onChange: (...args) => {
                config?.onChange?.(...args);
                handleSelectRowsChange(...args);
            }
        }
            : false),
        getSelectedRows
    };
}
